import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Global fetch interceptor for unauthorized responses
const originalFetch = window.fetch;
window.fetch = async function(...args) {
    try {
        const response = await originalFetch.apply(this, args);
        
        // Don't intercept login/auth endpoints - let them handle their own errors
        const url = args[0]?.toString() || '';
        if (url.includes('/auth/login') || url.includes('/auth/register')) {
            return response;
        }
        
        // Check for unauthorized responses (401 or 403)
        if (response.status === 401 || response.status === 403) {
            // Clone the response to read it without consuming it
            const clonedResponse = response.clone();
            
            try {
                const errorData = await clonedResponse.json();
                const errorMessage = errorData.message || '';
                
                // Check if message contains "Unauthorized" or related terms
                if (
                    errorMessage.toLowerCase().includes('unauthorized') ||
                    errorMessage.toLowerCase().includes('insufficient permissions') ||
                    errorMessage.toLowerCase().includes('unauthenticated')
                ) {
                    // Clear all auth data
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('user');
                    localStorage.removeItem('role');
                    
                    // Redirect to sign in page
                    window.location.href = '/sign-in';
                    
                    // Return the response to prevent further processing
                    return response;
                }
            } catch (e) {
                // If JSON parsing fails, check status text
                if (
                    response.statusText.toLowerCase().includes('unauthorized') ||
                    response.statusText.toLowerCase().includes('forbidden')
                ) {
                    // Clear all auth data
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('user');
                    localStorage.removeItem('role');
                    
                    // Redirect to sign in page
                    window.location.href = '/sign-in';
                }
            }
        }
        
        return response;
    } catch (error) {
        // Re-throw network errors
        throw error;
    }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);

reportWebVitals();
